import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref } from "vue";
const _hoisted_1 = ["data-unread"];
const _hoisted_2 = {
    key: 0,
    class: "absolute left-0 top-0 h-full w-[3px] bg-eorange-500",
    "aria-hidden": "true"
};
const _hoisted_3 = {
    key: 0,
    class: "absolute right-0 top-0 h-2.5 w-2.5 rounded-full border-2 border-white bg-eorange-500",
    "aria-hidden": "true"
};
const _hoisted_4 = { class: "flex-1 min-w-0 flex flex-col gap-[3px]" };
const _hoisted_5 = { class: "flex items-center gap-2" };
const _hoisted_6 = {
    key: 0,
    class: "flex-shrink-0 inline-flex items-center px-2 text-[11px] font-medium text-green-700 rounded-[9px]",
    style: { "height": "18px", "background-color": "#dcfce7" }
};
const _hoisted_7 = {
    key: 0,
    class: "text-[11px] text-[#9CA3AF] truncate"
};
const _hoisted_8 = { class: "flex flex-col items-end justify-center flex-shrink-0 gap-2" };
const _hoisted_9 = {
    key: 0,
    class: "min-w-[22px] rounded-full bg-eorange-500 px-1.5 py-0.5 text-center text-[11px] font-semibold leading-4 text-white",
    "data-test": "conversation-unread-badge"
};
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { conversationService } from "../services/conversation.service";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConversationListItem',
    props: {
        conversation: {},
        activeConversationId: {},
        currentUserId: {}
    },
    emits: ["select"],
    setup(__props) {
        const props = __props;
        const { locale, t } = useI18n();
        const isActive = computed(() => props.conversation.id === props.activeConversationId);
        const unreadCount = computed(() => props.conversation.unread_message_count ?? 0);
        const isUnread = computed(() => props.conversation.has_unread_messages || unreadCount.value > 0);
        const unreadBadge = computed(() => unreadCount.value > 99 ? "99+" : String(unreadCount.value));
        const rowBackgroundColor = computed(() => {
            if (isActive.value)
                return "#FFF5F3";
            if (isUnread.value)
                return "#FFF8F3";
            return "#FFFFFF";
        });
        const otherParticipant = computed(() => {
            if (!props.currentUserId)
                return props.conversation.participants[0] ?? null;
            return (props.conversation.participants.find((p) => p.id !== props.currentUserId) ??
                props.conversation.participants[0] ??
                null);
        });
        const otherName = computed(() => otherParticipant.value?.name ?? props.conversation.service_name_snapshot ?? '');
        const initials = computed(() => conversationService.getInitials(otherName.value));
        const avatarColor = computed(() => conversationService.getAvatarColor(props.conversation.id, props.conversation.status === "CLOSED"));
        const preview = computed(() => {
            return props.conversation.last_message_preview ?? "";
        });
        const relativeTime = computed(() => {
            const dateStr = props.conversation.last_message_at ?? props.conversation.created_at;
            const date = new Date(dateStr);
            const diffMs = Date.now() - date.getTime();
            const diffMins = Math.floor(diffMs / 60000);
            if (diffMins < 1)
                return t("conversation.relative.now");
            const formatter = new Intl.RelativeTimeFormat(locale.value, {
                numeric: "auto",
                style: "short",
            });
            if (diffMins < 60)
                return formatter.format(-diffMins, "minute");
            const diffHours = Math.floor(diffMins / 60);
            if (diffHours < 24)
                return formatter.format(-diffHours, "hour");
            return formatter.format(-Math.floor(diffHours / 24), "day");
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("button", {
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('select', __props.conversation))),
                class: "relative flex items-center w-full gap-3 px-4 text-left transition-colors border-b",
                "data-test": "conversation-list-item",
                "data-unread": isUnread.value ? 'true' : 'false',
                style: _normalizeStyle({
                    height: '88px',
                    backgroundColor: rowBackgroundColor.value,
                    borderBottomColor: isActive.value || isUnread.value ? '#FCE8E4' : '#F3F4F6',
                })
            }, [
                (isUnread.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2))
                    : _createCommentVNode("", true),
                _createElementVNode("div", {
                    class: "relative flex-shrink-0 flex items-center justify-center w-[42px] h-[42px] rounded-full text-white text-[14px] font-bold",
                    style: _normalizeStyle({ backgroundColor: avatarColor.value })
                }, [
                    _createTextVNode(_toDisplayString(initials.value) + " ", 1),
                    (isUnread.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3))
                        : _createCommentVNode("", true)
                ], 4),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", {
                            class: _normalizeClass(["text-[14px] text-[#1A1A1A] truncate", isUnread.value ? 'font-extrabold' : 'font-bold'])
                        }, _toDisplayString(otherName.value), 3),
                        (__props.conversation.status === 'ACTIVE')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(t)("conversation.status.active")), 1))
                            : _createCommentVNode("", true)
                    ]),
                    (__props.conversation.itinerary_code_snapshot)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.conversation.itinerary_code_snapshot), 1))
                        : _createCommentVNode("", true),
                    _createElementVNode("p", {
                        class: _normalizeClass(["text-[13px] truncate whitespace-nowrap overflow-hidden", isUnread.value ? 'font-semibold text-[#1F2937]' : 'text-[#6B7280]']),
                        "data-test": "conversation-message-preview"
                    }, _toDisplayString(preview.value), 3)
                ]),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", {
                        class: _normalizeClass(["text-[11px]", isUnread.value ? 'font-semibold text-eorange-600' : 'text-[#9CA3AF]'])
                    }, _toDisplayString(relativeTime.value), 3),
                    (unreadCount.value > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(unreadBadge.value), 1))
                        : _createCommentVNode("", true)
                ])
            ], 12, _hoisted_1));
        };
    }
});
